module.exports = __webpack_public_path__ + "static/img/z-5.2e000ab7.png";